import { useEffect } from 'react'
import Router from 'next/router'
import useAuth from '@/services/hooks/useAuth'

export interface Props {
  children: React.ReactElement
  onUnauthorized?: () => void
  isAdmin?: boolean
}

const AuthCheck: React.FC<Props> = ({
  children,
  onUnauthorized,
  isAdmin = false,
}) => {
  const { user } = useAuth()

  useEffect(() => {
    // Initially user will be undefined, so only want
    // to redirect when user is set to null
    if (typeof user === 'undefined') return

    if (user && (!isAdmin || user?.isSuperuser)) return

    if (onUnauthorized) {
      onUnauthorized()
    } else {
      if (window.location.pathname !== '/') {
        Router.replace('/')
      }
    }
  }, [user, onUnauthorized, isAdmin])

  if (user) {
    return children
  }

  return null
}

export default AuthCheck
